import { render, staticRenderFns } from "./LangFilter.vue?vue&type=template&id=58295028"
import script from "./LangFilter.vue?vue&type=script&lang=js"
export * from "./LangFilter.vue?vue&type=script&lang=js"
import style0 from "./LangFilter.vue?vue&type=style&index=0&id=58295028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports